/**
 * Asynchronously loads the component for InboxPage
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
